import React from 'react'

const SKELETON_ITEMS = [1, 2, 3, 4, 5, 6]

/**
 * ConnectorListSkeleton — matches the left panel shape for full-page loading:
 * tab bar + "Select Connector" header + Table-like row placeholders.
 */
export const ConnectorListSkeleton = () => (
  <>
    <div className="connector-mapping-tabs ant-tabs">
      <div className="ant-tabs-nav">
        <div className="ant-tabs-nav-list">
          <div className="ant-tabs-tab">
            <div className="skeleton-bar" style={{ width: '60%', height: 14 }} />
          </div>
          <div className="ant-tabs-tab">
            <div className="skeleton-bar" style={{ width: '60%', height: 14 }} />
          </div>
        </div>
      </div>
    </div>

    <div className="connector-mapping-list-wrapper">
      {/* Search input skeleton */}
      <div style={{ padding: '0 0 8px' }}>
        <div className="skeleton-bar" style={{ width: '100%', height: 32, borderRadius: 6 }} />
      </div>

      <div className="connector-mapping-list-content">
        {/* Header row skeleton */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '4px 8px', borderBottom: '1px solid var(--color-border-custom)' }}>
          <div className="skeleton-bar" style={{ width: 100, height: 14 }} />
          <div className="skeleton-bar" style={{ width: 14, height: 14, borderRadius: 4 }} />
        </div>

        {SKELETON_ITEMS.map((i) => (
          <div className="skeleton-item connector-mapping-cell" key={i} style={{ padding: '6px 8px', borderBottom: '1px solid var(--color-border-custom)' }}>
            <div className="connector-mapping-cell-content">
              <div className="skeleton-bar" style={{ width: '60%', height: 13 }} />
              <div className="skeleton-bar" style={{ width: '40%', height: 11, marginTop: 6 }} />
              <div className="skeleton-bar" style={{ width: '35%', height: 11, marginTop: 6 }} />
            </div>
            <div className="connector-mapping-cell-action">
              <div className="skeleton-bar" style={{ width: 40, height: 12 }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  </>
)

/**
 * RightPanelSkeleton — matches the final right panel shape:
 * toolbar placeholder + large SVG area placeholder.
 */
export const RightPanelSkeleton = () => (
  <>
    <div className="connector-mapping-toolbar skeleton-toolbar">
      <div className="skeleton-bar" style={{ width: 220, height: 28, borderRadius: 6 }} />
      <div className="skeleton-bar" style={{ width: 120, height: 28, borderRadius: 4 }} />
    </div>
    <div className="skeleton-svg-area">
      <div className="skeleton-bar skeleton-svg-box" />
    </div>
  </>
)

/**
 * FullPageSkeleton — renders both panels for the initial page load.
 * Replaces the Spin overlay in ConnectorMapping.
 */
const MappingSkeleton = () => (
  <div className="connector-mapping-container">
    <div className="connector-mapping-left-panel">
      <ConnectorListSkeleton />
    </div>
    <div className="connector-mapping-right-panel">
      <RightPanelSkeleton />
    </div>
  </div>
)

export default MappingSkeleton
